// Файл store.js

/**
 * Модуль обслуживает сценарий `store` в разделе `redux`.
 * Он содержит обработчики и данные, относящиеся к этой
 * части клиентского интерфейса.
 * Код связывает локальную логику с соседними компонентами без
 * дублирования общих правил.
 * Такое разделение упрощает сопровождение, проверку поведения и
 * дальнейшее расширение.
 */

import { configureStore } from '@reduxjs/toolkit';

import appReducer from './slice';



export const store = configureStore({
    reducer: {
        app: appReducer
    }
});


export default store;